module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"and":"e","at-least":"pelo menos","between":"entre","media":"foto(s)","media-number-error":"Selecione um número de mídias válido.","next":"Avançar","select":"Selecione","skip":"Pular","title":"Quais fotos quer usar?","up-to":"até"}}')
  delete Component.options._Ctor
}
